/**
 * Service to check if features are enabled.
 * Serves a one-stop place to check if features are enabled without having to
 * look directly at ENV vars in your component.
 */

export enum Feature {
	CloudSync = 'VITE_CLOUD_SYNC_FEATURE',
	RemoteSignature = 'VITE_REMOTE_SIGNATURE_FEATURE',
	SalesforceIntegration = 'VITE_SALESFORCE_INTEGRATION',
	FdlEmbed = 'VITE_FDL_EMBED',
}

export const useFeatureService = () => {
	const isEnabled = (featureName: Feature): boolean => {
		return import.meta.env[featureName] === 'true'
	}

	return { isEnabled }
}
